var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6352 20.727V12.7658H16.3585L16.7671 9.66219H13.6352V7.68102C13.6352 6.78274 13.8885 6.17058 15.2032 6.17058L16.8774 6.16991V3.39397C16.5878 3.35707 15.594 3.27246 14.4373 3.27246C12.0219 3.27246 10.3683 4.71854 10.3683 7.37364V9.66219H7.63672V12.7658H10.3683V20.727H13.6352Z",
    fill: "#F2F7FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_473_4332",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 10,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6352 20.727V12.7658H16.3585L16.7671 9.66219H13.6352V7.68102C13.6352 6.78274 13.8885 6.17058 15.2032 6.17058L16.8774 6.16991V3.39397C16.5878 3.35707 15.594 3.27246 14.4373 3.27246C12.0219 3.27246 10.3683 4.71854 10.3683 7.37364V9.66219H7.63672V12.7658H10.3683V20.727H13.6352Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_473_4332)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.dde40e0b40f257502c98a45327a137eb.svg";
export { ForwardRef as ReactComponent };